import { Option } from 'interfaces';

import { SubParentTypes } from './types';

export const SUBPROJECT_TYPES_OPTION_LIST: Option<SubParentTypes>[] = [
  {
    label: 'Нет',
    value: SubParentTypes.NONE,
  },
  {
    label: 'По дате',
    value: SubParentTypes.DATE,
  },
  {
    label: 'По типу',
    value: SubParentTypes.TYPE,
  },
];
